<!--
 * @Author: wsx
 * @Date: 2022-02-18 10:21:14
 * @LastEditTime: 2022-02-23 14:45:05
 * @Description: 头部
 * @FilePath: \hz-digital-twin\src\layout\components\MyHeader\index.vue
-->
<template>
  <div class="MyHeader">
    <div class="h-statistics">
      <template v-for="item in timeList" :key="item.id">
        <div
          class="h-statistics-item"
          :class="{ current: pointTimeId === item.id }"
        >
          <span class="value">
            <h-icon :icon="item.icon" font-size="20"></h-icon>
          </span>
          <i class="spot"></i>
          <span class="label">{{ item.name }}</span>
        </div>
      </template>
    </div>
    <div class="h-centre">
      <div class="h-menu h-menu-left">
        <template v-for="menu in menuLeft" :key="menu.menuId">
          <div
            class="h-menu-item"
            :class="{ current: currentMenu.menuId === menu.menuId }"
            @click="openMenu(menu, 1)"
          >
            <span class="h-label">{{ menu.name }}</span>
          </div>
        </template>
      </div>
      <div class="h-title">
        <!-- <img src="~@/assets/images/index/logo.png" alt="" /> -->
        <span>{{ title }}</span>
      </div>
      <div class="h-menu h-menu-right">
        <template v-for="menu in memuRight" :key="menu.menuId">
          <div
            class="h-menu-item"
            :class="{ current: currentMenu.menuId === menu.menuId }"
            @click="openMenu(menu, 1)"
          >
            <span class="h-label">{{ menu.name }}</span>
          </div>
        </template>
      </div>
      <div class="h-submenu" v-if="submenuState">
        <ul class="h-submenu-list">
          <template v-for="item in submenuList" :key="item.menuId">
            <li
              class="h-submenu-item"
              :class="{ current: currentSubmenu.menuId === item.menuId }"
              @click="openMenu(item, 2)"
            >
              <span class="label">{{ item.name }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="h-time">
      <div class="h-weather-icon">
        <h-icon icon="icon-duoyun" fontSize="50"></h-icon>
      </div>
      <div class="h-time-item">
        <span class="label">{{ currentDate }}</span>
        <span class="label">{{ currentTime }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, computed, onUnmounted, toRefs } from "vue";
// import { useI18n } from "vue-i18n";
import moment from "moment";
import _ from "lodash";
import HIcon from "@/components/global/HIcon.vue";
export default defineComponent({
  components: { HIcon },
  name: "MyHeader",
  setup(props, context) {
    const state = reactive({
      title: "开州治安防控平台",
      submenuState: false,
      baseMenu: [
        {
          menuId: "1",
          name: "数据可视化",
          path: "dataVisualization",
          children: []
        },
        {
          menuId: "2",
          name: "一标三实",
          path: "threeRealStandards",
          children: []
        },
        {
          menuId: "4",
          name: "视频监控",
          path: "videoSurveillance",
          children: []
        },
        {
          menuId: "5",
          name: "数据分析",
          path: "dataAnalysis",
          children: []
        }
      ],
      menuLeft: [],
      memuRight: [],
      submenuList: [],
      currentMenu: {
        menuId: "1"
      },
      currentSubmenu: {},
      timeList: [
        {
          id: "1",
          name: "清晨",
          icon: "icon-zaochen",
          start: 6,
          end: 12
        },
        {
          id: "2",
          name: "中午",
          icon: "icon-qingtian",
          start: 12,
          end: 16
        },
        {
          id: "3",
          name: "傍晚",
          icon: "icon-bangwan",
          start: 16,
          end: 19
        },
        {
          id: "4",
          name: "夜晚",
          icon: "icon-zaochen",
          start: 19,
          end: 6
        }
      ],
      currentHour: moment().format("HH"),
      currentTime: moment().format("HH:mm:ss"),
      currentDate: moment().format("YYYY-MM-DD")
    });
    const refData = toRefs(state);
    // const { t } = useI18n();
    // 设置菜单数据
    const setMenuData = () => {
      const list = _.cloneDeep(state.baseMenu);
      const lng = list.length;
      if (lng > 0) {
        if (lng % 2 === 0) {
          const i = lng / 2;
          state.menuLeft = list.splice(0, i);
          state.memuRight = list;
        } else {
          const i = Math.ceil(lng / 2);
          state.menuLeft = list.splice(0, i);
          state.memuRight = list;
        }
      }
    };

    const times = setInterval(() => {
      state.currentHour = moment().format("HH");
      state.currentTime = moment().format("HH:mm:ss");
      state.currentDate = moment().format("YYYY-MM-DD");
    }, 1000);
    onUnmounted(() => {
      clearInterval(times);
    });
    setMenuData();
    // 打开菜单
    const openMenu = (menu, type) => {
      if (type === 1) {
        state.submenuList = menu.children || [];
        state.currentMenu = menu;
        state.submenuState = state.submenuList.length > 0;
      } else if (type === 2) {
        state.currentSubmenu = menu;
        state.submenuState = false;
      }
      context.emit("openMenu", menu);
    };
    // 时间点
    const pointTimeId = computed(() => {
      const hour = Number(state.currentHour);
      let id = state.timeList[0].id;
      for (const item of state.timeList) {
        if (hour >= item.start && hour < item.end) {
          id = item.id;
          break;
        }
      }
      return id;
    });
    return {
      ...refData,
      // t,
      pointTimeId,
      openMenu
    };
  }
});
</script>
<style lang="scss" scoped>
@import "@/assets/utils.scss";
.MyHeader {
  color: #fff;
  height: 164px;
  padding-bottom: 90px;
  box-sizing: border-box;
  background-image: url("~@/assets/images/index/header.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  z-index: 0;
  @include flex-row-sb-c;
  &::before,
  &::after {
    content: "";
    position: absolute;
    bottom: 10%;
    height: 2px;
    width: 100%;
    background-color: #b1c83b;
  }
  &::before {
    left: 90%;
    bottom: 57%;
  }
  &::after {
    right: 90%;
    bottom: 57.5%;
  }
  .h-centre {
    position: relative;
    @include flex-row-c-c;
    .h-title {
      width: 770px;
      padding: 0 50px;
      box-sizing: border-box;
      font-size: 36px;
      font-weight: bold;
      margin-right: 10px;
      position: relative;
      letter-spacing: 3px;
      text-align: center;
      @include flex-row-c-c;
      @include font-linear(top, #f4e5cc, #cba86d);
      img {
        margin-right: 5px;
      }
    }
    .h-menu {
      position: absolute;
      color: #fff;
      font-size: 18px;
      @include flex-row-c-c;
      .h-menu-item {
        position: relative;
        height: 50px;
        width: 136px;
        cursor: pointer;
        @include flex-row-c-c;
        .h-label {
          display: inline-block;
          position: relative;
          z-index: 1;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
          background-image: url("~@/assets/images/index/menuBg.png");
          background-size: 100% 100%;
        }
        &.current::before {
          background-image: url("~@/assets/images/index/menuBg1.png");
        }
      }
      &.h-menu-left {
        right: 100%;
      }
      &.h-menu-right {
        left: 100%;
        .h-menu-item::before {
          transform: rotateY(180deg) !important;
        }
      }
    }
    .h-submenu {
      position: absolute;
      top: calc(100% + 35px);
      margin: auto;
      font-size: 18px;
      padding: 20px 0;
      height: 80px;
      box-sizing: border-box;
      background-image: url("~@/assets/images/index/submenuBg1.png");
      background-size: auto 100%;
      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 35px;
        background-image: url("~@/assets/images/index/submenuBg2.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      &::before {
        transform: rotateY(180deg);
        right: 100%;
      }
      &::after {
        left: 100%;
      }
      .h-submenu-list {
        height: 100%;
        @include flex-row-s-c;
        .h-submenu-item {
          height: 100%;
          padding: 0 10px;
          cursor: pointer;
          @include flex-row-s-c;
          &.current,
          &:hover {
            color: #3fc3ff;
          }
        }
      }
    }
  }
  .h-statistics {
    width: 240px;
    height: 0;
    border: 2px solid #0f748a;
    margin-left: 20px;
    position: relative;
    @include flex-row-se-c;
    .h-statistics-item {
      position: relative;
      width: 80px;
      @include flex-col-c-c;
      .value {
        position: absolute;
        bottom: calc(100%);
      }
      .label {
        position: absolute;
        top: calc(100%);
      }
      .spot {
        width: 8px;
        height: 8px;
        background-color: rgba($color: #50ffff, $alpha: 0.3);
        border-radius: 50%;
        margin: 5px;
      }
      &.current {
        color: #50ffff;
        .spot {
          background-color: #50ffff;
        }
      }
    }
  }
  .h-time {
    width: 240px;
    @include flex-row-s-c;
    .h-weather-icon {
      color: #c3aa80;
      margin-right: 5px;
      font-weight: 100;
    }
    .h-time-item {
      color: #c3aa80;
      margin-right: 10px;
      font-size: 16px;
      @include flex-col-c-s;
    }
  }
}
</style>
